import { TwoColumnLayout } from 'layouts';
import type { Media, VideoContentObject } from 'models';
import { Col, Row } from 'ui';
import { DescriptionCard, DetailsCard, WatchVideo } from '../../components';
import { UploadVideoCard } from './upload-video-card';

type P = {
  fullData?: Media;
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

const VideoDetailDraftContent = ({ fullData, trailerData, videoContentObject }: P) => (
  <TwoColumnLayout
    left={
      <Row>
        {fullData?.alts?.stream?.status === 'active' ? (
          <Col span={24}>
            <WatchVideo videoPath={fullData.alts.stream.path} />
          </Col>
        ) : null}

        <Col span={24}>
          <UploadVideoCard fullData={fullData} trailerData={trailerData} videoContentObject={videoContentObject} />
        </Col>
        <Col span={24}>
          <DescriptionCard videoContentObject={videoContentObject} />
        </Col>
      </Row>
    }
    right={<DetailsCard organization={videoContentObject.organization} />}
  />
);

export default VideoDetailDraftContent;
